


















































































































































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import {getValue} from '../../../../utils/util';
import RightProgress from './right-progress.vue';

@Component({
    components: {RightProgress}
})
export default class App extends Vue {
    @Prop({})
    userData: any;
    g = getValue;

    get RightData() {
        return this.userData.RightData;
    }

    get halfConsume () {
        let g = this.g;
        let RightData = this.RightData;
        let meituanMoney = +g(RightData, '用户下单统计.content[0].近180天金额', null);
        let dianpingMoney = +g(RightData, '用户下单统计.content[1].近180天金额', null);

        if (meituanMoney === null && dianpingMoney === null) {
            return '-';
        }
        return Math.round(meituanMoney + dianpingMoney);
    }

    get halfConsumeNum () {
        let g = this.g;
        let RightData = this.RightData;
        let meituanNum = +g(RightData, '用户下单统计.content[0].近180天次数', null);
        let dianpingNum = +g(RightData, '用户下单统计.content[1].近180天次数', null);
        if (meituanNum === null && dianpingNum === null) {
            return '-';
        }
        return meituanNum + dianpingNum;
    }
    get prefTagList() {
        let curTag = this.g(this.RightData, '偏好', []);
        curTag.sort((a, b) => {
            return b['偏好程度'] - a['偏好程度'];
        });
        curTag.map(item => {
            let rate:any = 0;
            if (item && item['偏好程度']) {
                rate = (item['偏好程度'] * 100).toFixed(2);
            }
            // item && item['偏好程度'] && ((parseInt as any)(item['偏好程度'] * 100) || 0);
            item.rate = rate;
            item.name = item['标签'];
            return item;
        });
        return curTag;
    }

    checkOverflow(el){
        let curOverflow = el.style.overflow;

        if ( !curOverflow || curOverflow === "visible" )
            el.style.overflow = "hidden";

        return el.clientWidth < el.scrollWidth;
    }

    addEllispeTag(el, color) {
        let childNodes = el.childNodes;
        let cur_w = 0;
        let sliceIndex = childNodes.length - 1;
        for(let i = 0; i < childNodes.length; i++) {
            cur_w += $(childNodes[i]).outerWidth(true);
            if (cur_w > el.scrollWidth) {
                el.setAttribute('sliceindex', i);
                sliceIndex = i;
                // console.log(cur_w,el.scrollWidth, 'right');
                break;
            }
        }
        let lastTwo = childNodes[sliceIndex - 1];
        if (lastTwo && lastTwo.className.indexOf('ellispe-tag') === -1) {
            lastTwo.className += ' ellispe-tag';
            lastTwo.style.color = color;
        }
        for (let i = sliceIndex; i < childNodes.length; i ++) {
            childNodes[i].style.visibility = 'hidden';
        }
    }

    resetTag (el) {
        let childNodes =  el.childNodes;
        let sliceIndex = el.getAttribute('sliceindex');
        // console.log( sliceIndex, el, 'sliceindex',);
        if (sliceIndex) {
            let lastTwo = childNodes[sliceIndex - 1];
            if (lastTwo) {
                lastTwo.className = lastTwo.className.replace('ellispe-tag', '');
            }
            for (let i = sliceIndex; i < childNodes.length; i ++) {
                childNodes[i].style.visibility = 'visible';
            }
            el.setAttribute('sliceindex', '');
        }

    }



    handleOverflowTags () {
        let restaurantTag = this.$refs.restaurantTag as HTMLElement;
        let consumeTimeTag = this.$refs.consumeTimeTag as HTMLElement;
        let preferAreaTag = this.$refs.preferAreaTag as HTMLElement;
        this.resetTag(restaurantTag);
        this.resetTag(consumeTimeTag);
        this.resetTag(preferAreaTag);

        if (this.checkOverflow(restaurantTag)) {
            this.addEllispeTag(restaurantTag, '#15B1FF');
        }
        if (this.checkOverflow(consumeTimeTag)) {
            this.addEllispeTag(consumeTimeTag, '#0CCBC1');
        }

        if (this.checkOverflow(preferAreaTag)) {
            this.addEllispeTag(preferAreaTag, '#C7AB04');
        }


    }

    mounted() {
        this.handleOverflowTags();
        this.$autoOn('window-resize', () => {
           this.handleOverflowTags();
        });
    }
}
